<template>
  <b-card v-if="paragraphObject.object_type" class="paragraph-object mb-4">
    <b-form @submit.prevent="editParagraphObject">

      <b-row>
        <b-col cols="auto" class="d-flex align-items-center flex-column justify-content-center">
          <div class="paragraph-object__drag-handle">
            <svg viewBox="0 0 421.285 421.285"><path d="M418.742,203.942c-0.3-0.2-0.5-0.5-0.8-0.8l-50.6-44.8c-4.1-3.6-10.5-3.2-14.1,0.9c-3.6,4.1-3.2,10.4,0.8,14l30.9,27.4h-164.3v-164.3l27.3,30.8c3.7,4.1,10,4.5,14.1,0.8s4.5-10,0.8-14.1l-44.8-50.5c-3.7-4.1-10-4.5-14.1-0.8c-0.3,0.3-0.6,0.5-0.8,0.8l-44.8,50.5c-3.6,4.1-3.2,10.5,0.9,14.1c4.1,3.6,10.4,3.2,14-0.8l27.3-30.8v164.3h-164.2l30.8-27.3c4.1-3.7,4.5-10,0.8-14.1c-3.7-4.1-10-4.5-14.1-0.8l-50.5,44.8c-4.1,3.7-4.5,10-0.8,14.1c0.3,0.3,0.5,0.6,0.8,0.8l50.5,44.8c4.1,3.6,10.5,3.2,14.1-0.9c3.6-4.1,3.2-10.4-0.8-14l-30.8-27.4h164.3v164.3l-27.3-30.8c-3.7-4.1-10-4.5-14.1-0.8c-4.1,3.7-4.5,10-0.8,14.1l44.8,50.5c3.7,4.1,10,4.5,14.1,0.8c0.3-0.3,0.6-0.5,0.8-0.8l44.8-50.5c3.6-4.1,3.2-10.5-0.9-14.1c-4.1-3.6-10.4-3.2-14,0.8l-27.4,30.8v-164.3h164.3l-30.8,27.3c-4.1,3.7-4.5,10-0.8,14.1c3.7,4.1,10,4.5,14.1,0.8l50.5-44.8C422.042,214.342,422.442,208.042,418.742,203.942z"/></svg>
          </div>
          <div class="paragraph-object__order">{{ paragraphObject.order }}</div>
        </b-col>
        <b-col>
          <b-form-group
            :id="'paragraph-object-infographic-group-' + paragraphObject.id"
            label="Infographic"
            label-for="paragraph-object-infographic"
            v-if="paragraphObject.object_type == 'infographic'"
            class="paragraph-object__field"
          >
            <b-form-file
              :id="'paragraph-object-infographic-' + paragraphObject.id"
              v-model="editForm.infographic"
              placeholder="Choose an image or drop it here..."
              ref="monitorImage"
              @change="onFileChange"
            ></b-form-file>
          </b-form-group>

          <b-form-group
            :id="'paragraph-object-data-group-' + paragraphObject.id"
            label="Data"
            label-for="paragraph-object-data"
            v-if="paragraphObject.object_type == 'data'"
            class="paragraph-object__field"
          >
            <b-form-file
              :id="'paragraph-object-data-' + paragraphObject.id"
              v-model="editForm.data"
              placeholder="Choose an image or drop it here..."
              ref="chapterObjectImage"
              @change="onFileChange"
            ></b-form-file>
          </b-form-group>

          <b-form-group
            id="paragraph-object-image-group"
            label="Image"
            label-for="paragraph-object-image"
            v-if="paragraphObject.object_type == 'image'"
            class="paragraph-object__field"
          >
            <b-form-file
              id="paragraph-object-image"
              v-model="editForm.image"
              placeholder="Choose an image or drop it here..."
              ref="chapterObjectImage"
              @change="onFileChange"
            ></b-form-file>
          </b-form-group>

          <b-row v-if="uploadedFileUrl && (paragraphObject.object_type == 'infographic' || paragraphObject.object_type == 'data' || paragraphObject.object_type == 'image')" class="mb-3">
            <b-col cols="12" sm="6">
              <img :src="uploadedFileUrl" class="img-fluid" />
            </b-col>
          </b-row>

          <b-form-group
            id="paragraph-object-text-group"
            label="Text"
            label-for="paragraph-object-text"
            v-if="paragraphObject.object_type == 'text'"
            class="paragraph-object__field"
          >
            <vue-editor v-model="editForm.text" :editor-toolbar="editorToolbar" @text-change="increaseEditorChangesCounter"/>
          </b-form-group>

          <b-form-group
            id="paragraph-object-sowhat-group"
            label="So What"
            label-for="paragraph-object-sowhat"
            v-if="paragraphObject.object_type == 'so_what'"
            class="paragraph-object__field"
          >
            <vue-editor v-model="editForm.sowhat" :editor-toolbar="editorToolbar" @text-change="increaseEditorChangesCounter"/>
          </b-form-group>

        </b-col>
        <b-col cols="4">

          <div class="paragraph-object__tt">

            <b-row class="mb-2">
              <b-col>
                <div class="paragraph-object__tt-title">3G & Targets</div>
              </b-col>
              <b-col cols="auto">
                <button type="button" class="paragraph-object__tt-add" title="Select 3G & Targets" @click="showAddTags('targets')"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </b-col>
            </b-row>
            <div v-if="editForm.targets.length == 0" class="paragraph-object__tt-empty">
              There are no targets, <a @click="showAddTags('targets')">add one</a>
            </div>
            <ul class="paragraph-object__tt-list" v-else>
              <li v-for="target in editForm.targets" :key="target.gandtarget_id">
                <p>{{ target.label_en }}</p>
                <button type="button" @click="removeTarget(target)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
              </li>
            </ul>

            <b-row class="mb-2">
              <b-col>
                <div class="paragraph-object__tt-title">Taxonomies</div>
              </b-col>
              <b-col cols="auto">
                <button type="button" class="paragraph-object__tt-add" title="Taxonomies" @click="showAddTags('taxonomies')"><svg viewBox="0 0 512 512"><path d="M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z"/><path d="M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z"/></svg></button>
              </b-col>
            </b-row>
            <div v-if="editForm.taxonomies.length == 0" class="paragraph-object__tt-empty">
              There are no taxonomies, <a @click="showAddTags('taxonomies')">add one</a>
            </div>
            <ul class="paragraph-object__tt-list" v-else>
              <li v-for="taxonomy in editForm.taxonomies" :key="taxonomy.tax_id">
                <p>{{ taxonomy.label_en }}</p>
                <button type="button" @click="removeTaxonomy(taxonomy)"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path d="M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"></path></svg></button>
              </li>
            </ul>


          </div>

        </b-col>
      </b-row>

      <div class="paragraph-object-alert">
        <b-alert
          :variant="alert.type"
          dismissible
          fade
          :show="alert.show"
          @dismissed="alert.show=0"
          @dismiss-count-down="alertCountDownChanged"
        >
          {{ alert.content }}
        </b-alert>
      </div>

      <div class="text-right">
        <div class="paragraph-object__actions">
          <button type="button" class="paragraph-object__action mr-3" @click="requestParagraphObjectArchive()" v-b-popover.hover.top="'Archive'">
            <svg viewBox="0 0 512 512"><path d="M469.333,85.333H249.75l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125h-160C19.135,42.667,0,61.802,0,85.333v341.333c0,23.531,19.135,42.667,42.667,42.667h426.667c23.531,0,42.667-19.135,42.667-42.667V128C512,104.469,492.865,85.333,469.333,85.333z"/></svg>
          </button>
          <button type="button" class="paragraph-object__action mr-2" @click="requestParagraphObjectDelete()" v-b-popover.hover.top="'Delete'">
            <svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg>
          </button>
        </div>
        <b-button type="submit" variant="primary" v-if="showSave"><b-spinner small variant="light" v-if="isLoading"></b-spinner> Save</b-button>
      </div>

    </b-form>

    <MonitorTags
      :tagType="selectedTagType"
      @requestAddTag="addTag"
      :modalTagId="modalTagsId"
      :currentTargets="editForm.targets"
      :currentTaxonomies="editForm.taxonomies"
    />

    <b-modal
      :id="'bv-modal-delete-paragraph-object' + paragraphObject.id"
      size="lg"
      :ok-disabled="deleteCheck != 'DELETE'"
      centered
      @ok="paragraphObjectDelete"
    >
      <template v-slot:modal-title>
        Move to Trash
      </template>
      <p>Are you sure you want to move {{ paragraphObject.object_type }} paragraph object to the trash?</p>
      <b-alert variant="warning" show>
        <strong>WARNING: This action will update and delete this object also in the User Dashboard.</strong><br>
        Are you sure you want to proceed?
      </b-alert>
      <p>Type <strong>DELETE</strong> to delete the paragraph object</p>
      <input type="text" class="form-control" v-model="deleteCheck">
    </b-modal>

    <b-modal
      :id="'bv-modal-archive-paragraph-object' + paragraphObject.id"
      size="lg"
      :ok-disabled="archiveCheck != 'ARCHIVE'"
      centered
      @ok="paragraphObjectArchive"
    >
      <template v-slot:modal-title>
        Archive
      </template>
      <p>Are you sure you want to archive {{ paragraphObject.object_type }} paragraph object?</p>
      <b-alert variant="warning" show>
        <strong>WARNING: This action will delete this object in the User Dashboard and will store this object.</strong> Are you sure you want to proceed?
      </b-alert>
      <p>Type <strong>ARCHIVE</strong> to archive the paragraph object</p>
      <input type="text" class="form-control" v-model="archiveCheck">
    </b-modal>

  </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import { VueEditor } from "vue2-editor";
import MonitorTags from "@/components/MonitorTags";

import {
  MONITOR_PARAGRAPH_OBJECT_DELETE,
  MONITOR_PARAGRAPH_OBJECT_ARCHIVE,
  MONITOR_PARAGRAPH_OBJECT_EDIT,
} from "@/store/actions.type";

import {
  STATE_MONITORS_RECENT_TARGETS_SET,
  STATE_MONITORS_RECENT_TAXONOMIES_SET
} from "@/store/mutations.type";

export default {
  name: 'MonitorParagraphObject',
  props: ['paragraphObject'],
  components: {
    VueEditor,
    MonitorTags
  },
  data() {
    return {
      isLoading: false,
      objectType: '',
      editForm: {
        infographic: null,
        text: '',
        data: null,
        image: null,
        sowhat: '',
        targets: [],
        taxonomies: []
      },
      fileChanged: false,
      uploadedFileUrl: null,
      selectedTagType: 'targets',
      modalTagsId: '',
      editorToolbar: [
        ["bold", "italic", "underline"],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ 'align': [] }],
        ['blockquote'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        ['clean']
      ],
      alert: {
        show: 0,
        type: '',
        content: ''
      },
      archiveCheck: '',
      deleteCheck: '',
      showSave: false,
      editorChangesCounter: 0
    }
  },
  computed: {
    ...mapGetters(["taxonomies", "targets", "monitorTags", "monitorCurrent"])
  },
  methods: {
    alertCountDownChanged(dismissCountDown) {
      this.alert.show = dismissCountDown
    },
    editParagraphObject() {

      if(!this.validateParagraphObjectData()) {
        return
      }

      this.isLoading = true;

      let paragraphObjectData = new FormData();

      if (this.paragraphObject.object_type === 'infographic') {
        if(this.editForm.infographic != null && this.fileChanged) {
          paragraphObjectData.set('value_file', this.editForm.infographic);
        }
      } else if (this.paragraphObject.object_type === 'text') {
        paragraphObjectData.set('value_text', this.editForm.text);
      } else if (this.paragraphObject.object_type === 'data') {
        if(this.editForm.data != null && this.fileChanged) {
          paragraphObjectData.set('value_file', this.editForm.data);
        }
      } else if (this.paragraphObject.object_type === 'image') {
        if(this.editForm.image != null && this.fileChanged) {
          paragraphObjectData.set('value_file', this.editForm.image);
        }
      } else if (this.paragraphObject.object_type === 'so_what') {
        paragraphObjectData.set('value_text', this.editForm.sowhat);
      }

      let paragraphObjectTargets = [];
      let i = 0;
      for (i = 0; i < this.editForm.targets.length; i++) {
        paragraphObjectTargets.push(this.editForm.targets[i].gandtarget_id);
      }
      paragraphObjectData.append('gandtargets', JSON.stringify(paragraphObjectTargets));
      let paragraphObjectTaxonomies = [];
      for (i = 0; i < this.editForm.taxonomies.length; i++) {
        paragraphObjectTaxonomies.push(this.editForm.taxonomies[i].tax_id);
      }
      paragraphObjectData.append('taxonomies', JSON.stringify(paragraphObjectTaxonomies));

      let payload = {
        paragraphId: this.paragraphObject.paragraph,
        paragraphObjectId: this.paragraphObject.id,
        paragraphObjectData: paragraphObjectData
      }

      this.$store.dispatch(MONITOR_PARAGRAPH_OBJECT_EDIT, payload).then(() => {
        this.$bvToast.toast(`Paragraph object ${this.paragraphObject.object_type} has been edited successfully`, {
          title: 'Paragraph object created',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.isLoading = false;
        this.resetChangesAndSave();
        this.$emit('paragraphObjectCreated');
      });
    },
    validateParagraphObjectData() {

      let idGender = null;
      let idGeolocalization = null;
      let idGeneration = null;
      // let idTarget = null;

      for (let i = 0; i < this.targets.length; i++) {
        if(this.targets[i].label == 'GENERE') {
          idGender = this.targets[i].gandtarget_id;
        }
        if(this.targets[i].label == 'GEOLOCALIZZAZIONE') {
          idGeneration = this.targets[i].gandtarget_id;
        }
        if(this.targets[i].label == 'GENERAZIONE') {
          idGeolocalization = this.targets[i].gandtarget_id;
        }
        // if(this.targets[i].label == 'TARGET') {
        //   idTarget = this.targets[i].gandtarget_id;
        // }
      }

      let errorGender = true;
      let errorGeolocalization = true;
      let errorGeneration = true;
      // let errorTarget = true;

      if(this.editForm.targets.length > 0) {
        for (var k = 0; k < this.editForm.targets.length; k++) {
          if(this.editForm.targets[k].lev_1 === idGender) {
            errorGender = false;
          }
          if(this.editForm.targets[k].lev_1 === idGeolocalization) {
            errorGeolocalization = false;
          }
          if(this.editForm.targets[k].lev_1 === idGeneration) {
            errorGeneration = false;
          }
          // if(this.editForm.targets[k].lev_1 === idTarget) {
          //   errorTarget = false;
          // }
        }
      }

      if(errorGender || errorGeolocalization || errorGeneration || this.editForm.taxonomies.length == 0) {
        this.alert.show = 3;
        this.alert.type = 'danger';
        this.alert.content = 'You must select at least one gender, geolocalization, generation and taxonomy';
        this.isLoading = false;
        return false
      } else {
        return true
      }

    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.uploadedFileUrl = URL.createObjectURL(file);
      this.fileChanged = true;
      this.showSaveButton();
    },
    showAddTags(tagType) {
      this.selectedTagType = tagType;
      this.$bvModal.show(this.modalTagsId)
    },
    addTag(tag) {
      if(this.selectedTagType === 'targets') {
        if (!this.editForm.targets.includes(tag)) {
          this.editForm.targets.push(tag);
          this.showSaveButton();
          this.$store.commit(STATE_MONITORS_RECENT_TARGETS_SET, tag);
        }
      } else {
        if (!this.editForm.taxonomies.includes(tag)) {
          this.editForm.taxonomies.push(tag);
          this.showSaveButton();
          this.$store.commit(STATE_MONITORS_RECENT_TAXONOMIES_SET, tag);
        }
      }
      // this.$bvModal.hide(this.modalTagsId)    
    },
    removeTarget: function(target) {
      var targetIndexToRemove = this.editForm.targets.indexOf(target);
      if (targetIndexToRemove > -1) {
        this.editForm.targets.splice(targetIndexToRemove, 1);
        this.showSaveButton();
      }
    },
    removeTaxonomy: function(taxonomy) {
      var taxonomyIndexToRemove = this.editForm.taxonomies.indexOf(taxonomy);
      if (taxonomyIndexToRemove > -1) {
        this.editForm.taxonomies.splice(taxonomyIndexToRemove, 1);
        this.showSaveButton();
      }
    },
    requestParagraphObjectDelete() {
      this.deleteCheck = '';
      this.$bvModal.show('bv-modal-delete-paragraph-object' + this.paragraphObject.id);
    },
    paragraphObjectDelete() {
      let payload = {
        paragraphId: this.paragraphObject.paragraph,
        paragraphObjectId: this.paragraphObject.id,
      }
      this.$store.dispatch(MONITOR_PARAGRAPH_OBJECT_DELETE, payload).then(() => {
        this.$bvToast.toast(`Paragraph object ${this.paragraphObject.object_type} has been moved to trash successfully`, {
          title: 'Paragraph object moved to trash',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.isLoading = false;
        this.$emit('paragraphObjectDeleted');
        this.deleteCheck = '';
      });
    },
    requestParagraphObjectArchive() {
      this.archiveCheck = '';
      this.$bvModal.show('bv-modal-archive-paragraph-object' + this.paragraphObject.id);
    },
    paragraphObjectArchive() {
      let paragraphObjectData = new FormData();
      paragraphObjectData.append('paragraph_obj_id', this.paragraphObject.id);

      this.$store.dispatch(MONITOR_PARAGRAPH_OBJECT_ARCHIVE, paragraphObjectData).then(() => {
        this.$bvToast.toast(`Paragraph object ${this.paragraphObject.object_type} has been archived`, {
          title: 'Paragraph object archived',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.isLoading = false;
        this.$emit('paragraphObjectArchived');
        this.archiveCheck = '';
      });
    },
    increaseEditorChangesCounter() {
      this.editorChangesCounter++;
      // Il primo change è il load del testo, lo ignoriamo
      if(this.editorChangesCounter > 1) {
        this.showSaveButton();
      }
    },
    showSaveButton() {
      this.showSave = true;
    },
    resetChangesAndSave() {
      // Dopo il salvataggio il testo è già caricato nell'editor
      this.editorChangesCounter = 1;
      this.showSave = false;
    }
  },
  mounted() {
    
    if (this.paragraphObject.object_type == 'infographic') {
      // this.editForm.infographic = this.paragraphObject.value_file;
      this.uploadedFileUrl = this.paragraphObject.value_file;
    }
    if (this.paragraphObject.object_type == 'data') {
      // this.editForm.data = this.paragraphObject.value_file;
      this.uploadedFileUrl = this.paragraphObject.value_file;
    }
    if (this.paragraphObject.object_type == 'image') {
      // this.editForm.image = this.paragraphObject.value_file;
      this.uploadedFileUrl = this.paragraphObject.value_file;
    }
    if (this.paragraphObject.object_type == 'text') {
      this.editForm.text = this.paragraphObject.value_text;
    }
    if (this.paragraphObject.object_type == 'so_what') {
      this.editForm.sowhat = this.paragraphObject.value_text;
    }

    this.modalTagsId = 'bv-modal-add-tags-' + this.paragraphObject.id;

    if(this.paragraphObject.gandtargets.length > 0) {
      for(let i = 0; i < this.paragraphObject.gandtargets.length; i++){
        for(let j = 0; j < this.targets.length; j++) {
          if(this.paragraphObject.gandtargets[i] === this.targets[j].gandtarget_id) {
            this.editForm.targets.push(this.targets[j]);
            break;
          }
        }
      }
    }

    if(this.paragraphObject.taxonomies.length > 0) {
      for(let i = 0; i < this.paragraphObject.taxonomies.length; i++){
        for(let j = 0; j < this.taxonomies.length; j++) {
          if(this.paragraphObject.taxonomies[i] === this.taxonomies[j].tax_id) {
            this.editForm.taxonomies.push(this.taxonomies[j]);
            break;
          }
        }
      }
    }

  }
}
</script>

<style lang="scss">
.paragraph-object {

  &__drag-handle {

    svg {
      width: rem(20px);
      height: rem(20px);
    }

    &:hover {
      cursor: move;
    }
  }

  &__drag-ghost {
    opacity: 0.5;
  }

  &__order {
    font-size: 0.6125rem;
    padding: 0.125rem 0.25rem;
    text-transform: uppercase;
    display: inline-block;
    line-height: 1;
    margin-top: 0.5rem;
    background: rgba(0,0,0,.1);
    color: #000;
    font-weight: 700;
  }

  &__field > label {
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: rem(16px);
  }

  &__tt-title {
    text-transform: uppercase;
    font-size: rem(15px);
    color: #000;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    font-weight: 700;
  }

  &__tt-add {
    border: 0;
    margin: 0;
    padding: 0;
    background: none;

    svg {
      width: rem(20px);
      height: rem(20px);
      fill: $color-genoa;
      transition: fill .3s ease;
    }

    &:focus {
      outline: none;
    }
    
    &:hover {

      svg {
        fill: $color-java;
      }
    }
  }

  &__tt-empty {
    font-size: rem(13px);
    font-family: $font-family-roboto;
    color: #000;
    margin-bottom: rem(16px);

    a {
      font-weight: 700;
      color: $color-java;
      cursor: pointer;
      transition: color .3s ease;

      &:hover {
        color: $color-genoa;
      }
    }
  }

  &__tt-list {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-bottom: rem(16px);

    li {
      margin-right: rem(8px);
      margin-bottom: rem(8px);
      padding: rem(4px) rem(8px);    
      border: 1px solid rgba(0, 0, 0, 0.2);
      display: inline-block;
      font-weight: 600;

      &:last-child {
        margin-right: 0;
      }

      p {
        margin-bottom: 0;
        font-size: rem(13px);
        color: $color-java;
        text-transform: uppercase;
        display: inline-block;
        margin-right: rem(8px);
      }

      button {
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        vertical-align: inherit;

        svg {
          width: rem(10px);
          height: rem(10px);
          fill: #cbcbcb;
        }
        
        &:hover {

          svg {
            fill: $color-sunset;
          }
        }

        &:focus {
          outline: none;
        }
      }
    }
  }

  &__actions {
    display: inline-block;
    margin-right: rem(16px);
  }

  &__action {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill: $color-java;
      }
    }
  }
}

.menubar {
  margin-bottom: rem(8px);

  &__button {
    border: 0;
    padding: 0;
    font-size: rem(10px);
    padding: rem(3px) rem(8px);
    margin-right: rem(4px);
    background-color: #f1f1f1;
    transition: all .3s ease;
    font-weight: 600;

    &:hover {
      background-color: $color-java;
      color: #fff;
    }
  }

  + div {
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: rem(16px);
    font-size: rem(14px); 
  }
}

.ProseMirror {
  outline: none;
  color: #000;

  h1, h2, h3 {
    margin-bottom: rem(24px);
  }

  blockquote {
    background: rgba(0, 0, 0, 0.1);
    padding: rem(8px);

    :last-child {
      margin-bottom: 0;
    }
  }

  li {

    :last-child {
      margin-bottom: 0;
    }
  }
}

</style>